import React from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faWarning, faCircleExclamation, faCheckCircle, faInfoCircle} from '@fortawesome/free-solid-svg-icons'
import {NOTIFICATION_TYPES} from 'const/notifications'

export const NotificationIcon = ({icon}) => {
  let defaultIcon = faCheckCircle

  if (icon === NOTIFICATION_TYPES.error) {
    defaultIcon = faCircleExclamation
  } else if (icon === NOTIFICATION_TYPES.info) {
    defaultIcon = faInfoCircle
  } else if (icon === NOTIFICATION_TYPES.warning) {
    defaultIcon = faWarning
  }

  return <FontAwesomeIcon icon={defaultIcon} />
}

export default NotificationIcon
